import { getUserPath, TFirebaseUser } from '@/entities/chat/@x/user'
import {
  clientDatabase,
  Database,
  FirebaseDatabase,
  isError,
  Unsubscribe,
} from '@/shared/lib'

import { TBadge } from './schema'

export const DefaultBadges = {
  badgeChat: 0,
  badgeGuestBooking: 0,
  badgeHostBooking: 0,
  badgeGuestInbox: 0,
  badgeHostInbox: 0,
}

export class BadgeDatabase extends FirebaseDatabase {
  constructor(database: Database = clientDatabase) {
    super(database)
  }

  private badgeUnsubscribe: Unsubscribe | null = null

  async getBadges(userId: number): Promise<TBadge> {
    const result = await this.getValue<TFirebaseUser>({
      path: getUserPath(userId),
    })

    if (isError(result) || !result.data) {
      return DefaultBadges
    }

    return {
      badgeChat: result.data.badge_chat,
      badgeGuestBooking: result.data.badge_guest_booking,
      badgeHostBooking: result.data.badge_host_booking,
      badgeGuestInbox: result.data.badge_guest_inbox,
      badgeHostInbox: result.data.badge_host_inbox,
    }
  }

  subscribeBadges(userId: number, onUpdate: (badge: TBadge) => void) {
    if (this.badgeUnsubscribe) {
      this.badgeUnsubscribe()
    }

    this.badgeUnsubscribe = this.subscribe<TFirebaseUser>({
      path: getUserPath(userId),
      onUpdate: user => {
        onUpdate({
          badgeChat: user.badge_chat,
          badgeGuestBooking: user.badge_guest_booking,
          badgeHostBooking: user.badge_host_booking,
          badgeGuestInbox: user.badge_guest_inbox,
          badgeHostInbox: user.badge_host_inbox,
        })
      },
    })

    return {
      unsubscribe: () => {
        if (this.badgeUnsubscribe) {
          this.badgeUnsubscribe()
          this.badgeUnsubscribe = null
        }
      },
    }
  }
}
